<button *ngIf="canUse && !embedded" pButton type="button" icon="pi pi-search" class="p-button-text p-button-rounded qs-trigger"
  [pTooltip]="'quickSearch.trigger' | t" tooltipPosition="bottom" (click)="open()"></button>

<!-- Shared content — see global-search.component.html's own comment on this same pattern. Moved
     the AI/help toggles out of the standalone-only input row and into here so both modes get them. -->
<ng-template #content>
  <div class="qs-mode-toolbar" *ngIf="embedded">
    <button type="button" class="qs-ai-toggle" [class.qs-ai-toggle--on]="aiMode" (click)="toggleAiMode()"
      [pTooltip]="'quickSearch.ai.toggleTooltip' | t" tooltipPosition="bottom">
      <i class="pi pi-sparkles"></i> {{ 'quickSearch.ai.toggle' | t }}
    </button>
    <button type="button" class="qs-help-toggle" [class.qs-help-toggle--on]="showHelp" (click)="toggleHelp()"
      [pTooltip]="'quickSearch.help.toggleTooltip' | t" tooltipPosition="bottom">
      <i class="pi pi-question-circle"></i>
    </button>
  </div>

  <!-- ── "How this works" — a tap-to-try recap, not a static wall of text ─────────────────── -->
  <div class="qs-help" *ngIf="showHelp">
    <button type="button" class="qs-help-back" (click)="toggleHelp()">
      <i class="pi pi-arrow-left"></i> {{ 'quickSearch.help.back' | t }}
    </button>

    <div class="qs-help-section">
      <div class="qs-help-heading"><i class="pi pi-compass"></i> {{ 'quickSearch.help.basicsTitle' | t }}</div>
      <p class="qs-help-text">{{ 'quickSearch.help.basicsText' | t }}</p>
    </div>

    <div class="qs-help-section">
      <div class="qs-help-heading"><i class="pi pi-arrows-alt"></i> {{ 'quickSearch.help.sizesTitle' | t }}</div>
      <p class="qs-help-text">{{ 'quickSearch.help.sizesExactText' | t }}</p>
      <div class="qs-help-examples">
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('4in x 3in x 8ft teak')">4in x 3in x 8ft teak</button>
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('90cm x 230cm ghana teak')">90cm x 230cm ghana teak</button>
      </div>
      <p class="qs-help-text">{{ 'quickSearch.help.sizesRangeText' | t }}</p>
      <div class="qs-help-examples">
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('girth over 90cm')">girth over 90cm</button>
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('width between 6 and 10 inch')">width between 6 and 10 inch</button>
      </div>
      <p class="qs-help-text">{{ 'quickSearch.help.sizesTypeText' | t }}</p>
      <div class="qs-help-examples">
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('4x3 square')">4x3 square</button>
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('90 round')">90 round</button>
      </div>
      <p class="qs-help-text">{{ 'quickSearch.help.sizesAnyText' | t }}</p>
      <div class="qs-help-examples">
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('4x3x?')">4x3x?</button>
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('4x?x8')">4x?x8</button>
      </div>
    </div>

    <div class="qs-help-section">
      <div class="qs-help-heading"><i class="pi pi-tags"></i> {{ 'quickSearch.help.speciesTitle' | t }}</div>
      <p class="qs-help-text">{{ 'quickSearch.help.speciesText' | t }}</p>
      <div class="qs-help-examples">
        <button type="button" class="qs-chip qs-help-example" (click)="tryExample('teek ghana a-grade')">teek ghana a-grade</button>
      </div>
    </div>

    <div class="qs-help-section">
      <div class="qs-help-heading"><i class="pi pi-th-large"></i> {{ 'quickSearch.help.legendTitle' | t }}</div>
      <div class="qs-help-legend">
        <div class="qs-help-legend-row"><span class="qs-dot qs-avail"></span>{{ 'quickSearch.help.legendAvailable' | t }}</div>
        <div class="qs-help-legend-row"><span class="qs-dot qs-pending"></span>{{ 'quickSearch.help.legendPending' | t }}</div>
        <div class="qs-help-legend-row"><span class="qs-dot qs-process"></span>{{ 'quickSearch.help.legendProcess' | t }}</div>
        <div class="qs-help-legend-row"><span class="qs-dot qs-arriving"></span>{{ 'quickSearch.help.legendArriving' | t }}</div>
      </div>
    </div>

    <div class="qs-help-section qs-help-section--ai">
      <div class="qs-help-heading"><i class="pi pi-sparkles"></i> {{ 'quickSearch.help.aiTitle' | t }}</div>
      <p class="qs-help-text">{{ 'quickSearch.help.aiText' | t }}</p>
    </div>
  </div>

  <ng-container *ngIf="!showHelp">
  <div class="qs-ai-bar" *ngIf="aiMode">
    <button pButton type="button" [label]="'quickSearch.ai.ask' | t" icon="pi pi-sparkles" class="p-button-sm"
      [loading]="aiSearching" [disabled]="!queryText.trim()" (click)="askAi()"></button>
    <span class="qs-ai-credits" *ngIf="aiCredits">
      {{ 'quickSearch.ai.creditsUsedThisCall' | t }}: {{ aiCredits.usedThisCall }}
      <span *ngIf="aiCredits.usagePct != null"> · {{ aiCredits.usagePct }}% {{ 'quickSearch.ai.used' | t }}</span>
    </span>
    <span class="qs-ai-error" *ngIf="aiError">{{ aiError | t }}</span>
  </div>

  <div class="qs-parse-row" *ngIf="query && query.matches.length">
    <span class="qs-chip" [class.qs-chip--unrecognized]="m.field === 'unrecognized'"
          [class.qs-chip--recognized]="m.field !== 'unrecognized'" *ngFor="let m of query.matches">
      {{ m.label }}
      <i class="pi pi-question-circle qs-fuzzy-mark" *ngIf="m.fuzzy" [pTooltip]="'quickSearch.fuzzyTooltip' | t" tooltipPosition="top"></i>
      <i class="pi pi-exclamation-triangle qs-unrecognized-mark" *ngIf="m.field === 'unrecognized'" [pTooltip]="'quickSearch.unrecognizedTooltip' | t" tooltipPosition="top"></i>
    </span>
  </div>

  <!-- "Did you mean?" — plausible-but-not-confident species matches, never auto-picked -->
  <div class="qs-didyoumean" *ngIf="query && query.ambiguousSpecies.length">
    <div class="qs-didyoumean-row" *ngFor="let a of query.ambiguousSpecies">
      <span class="qs-didyoumean-label">{{ 'quickSearch.didYouMean' | t }} "{{ a.word }}"?</span>
      <button type="button" class="qs-recent-pill" *ngFor="let c of a.candidates" (click)="selectAmbiguousSpecies(c)">
        <span>{{ c.name }}</span>
      </button>
    </div>
  </div>

  <div class="qs-body">
    <div class="qs-loading" *ngIf="searching">
      <i class="pi pi-spin pi-spinner"></i> {{ 'quickSearch.searching' | t }}
    </div>

    <ng-container *ngIf="!searching && searched">

      <!-- Sources the plan does not include are simply left out. One quiet line says so (no dialog). -->
      <div class="qs-locked" *ngIf="isLocked('stock') || isLocked('mill')">
        <i class="pi pi-lock"></i>
        <span>
          <ng-container *ngIf="isLocked('stock')">{{ 'quickSearch.lockedStock' | t }} </ng-container>
          <ng-container *ngIf="isLocked('mill')">{{ 'quickSearch.lockedMill' | t }} </ng-container>
          <a href="javascript:void(0)" (click)="openPlans()">{{ 'quickSearch.seePlans' | t }}</a>
        </span>
      </div>

      <div class="qs-empty" *ngIf="!hasAnyResult">
        <i class="pi pi-inbox"></i>
        <p>{{ 'quickSearch.notFound' | t }}</p>
      </div>

      <ng-container *ngIf="hasAnyResult">
        <!-- Available now -->
        <div class="qs-bucket" *ngIf="result?.available?.length">
          <div class="qs-bucket-label qs-avail"><span class="qs-dot"></span>{{ 'quickSearch.availableNow' | t }} — {{ result?.available?.length }}</div>
          <div class="qs-row-wrap" *ngFor="let g of result?.available; let i = index">
            <div class="qs-row" [class.qs-row--clickable]="g.lots?.length && pageAccess.canOpen('overview')"
                 [class.qs-row--active]="isRowHighlighted(availableBaseIndex + i)" (click)="openAvailableGroup(g)">
              <div class="qs-row-main">
                <span class="qs-row-title">{{ g.productName }}<span *ngIf="squareDims(g)"> · {{ squareDims(g) }}</span></span>
                <span class="qs-row-meta">
                  <span class="qs-meta-pill qs-meta-pill--site" *ngIf="g.siteName"><i class="pi pi-map-marker"></i>{{ g.siteName }}</span>
                  <span class="qs-meta-pill qs-meta-pill--origin" *ngIf="g.originName"><i class="pi pi-globe"></i>{{ g.originName }}</span>
                  <span class="qs-meta-pill qs-meta-pill--quality" *ngIf="g.qualityLabel">{{ g.qualityLabel }}</span>
                </span>
                <div class="qs-row-stats">
                  <span class="qs-stat" *ngIf="g.availableCft != null"><i class="pi pi-th-large"></i>{{ g.availableCft | number:'1.0-0' }} CFT</span>
                  <span class="qs-stat" *ngIf="g.availablePieces != null"><i class="pi pi-copy"></i>{{ g.availablePieces }} {{ 'quickSearch.pcs' | t }}</span>
                </div>
              </div>
              <div class="qs-row-fig">
                {{ g.availableCbm | number:'1.1-2' }} CBM
                <button type="button" class="qs-expand-toggle" [pTooltip]="'quickSearch.details' | t" tooltipPosition="top"
                        (click)="$event.stopPropagation(); toggleExpand(rowKey(g,'available'), g)">
                  <i class="pi" [class.pi-chevron-down]="!isExpanded(rowKey(g,'available'))" [class.pi-chevron-up]="isExpanded(rowKey(g,'available'))"></i>
                </button>
                <i class="pi pi-chevron-right qs-row-arrow" *ngIf="g.lots?.length"></i>
              </div>
            </div>

            <div class="qs-expand" *ngIf="isExpanded(rowKey(g,'available'))" (click)="$event.stopPropagation()">
              <div class="qs-expand-grid">
                <div class="qs-expand-block" *ngIf="flags.showPriceInvoice && g.invoiceAmount != null">
                  <span class="qs-expand-label">{{ 'quickSearch.invoiceAmount' | t }}</span>
                  <span class="qs-expand-value">{{ g.invoiceAmount | number:'1.0-2' }} {{ g.invoiceCurrency }}</span>
                </div>
                <div class="qs-expand-block" *ngIf="flags.showBlNumber && g.blNumber">
                  <span class="qs-expand-label">{{ blLabelKey(g.blLocal) | t }}</span>
                  <span class="qs-expand-value">{{ g.blNumber }}</span>
                </div>
                <a class="qs-expand-link" *ngIf="flags.showConsignmentLink && g.consignmentEncodedId"
                   [routerLink]="['/consignments/consignment-view', g.consignmentEncodedId]">
                  {{ 'quickSearch.viewConsignment' | t }} <i class="pi pi-external-link"></i>
                </a>

                <ng-container *ngIf="flags.showMixedBreakdown && g.mixedConsignments">
                  <div class="qs-mixed-label"><i class="pi pi-sitemap"></i> {{ 'quickSearch.mixedConsignments' | t }} · {{ g.mixedConsignmentCount }}</div>
                  <div class="qs-loading-inline" *ngIf="breakdowns[rowKey(g,'available')] === 'loading'">
                    <i class="pi pi-spin pi-spinner"></i>
                  </div>
                  <div class="qs-breakdown-row" *ngFor="let ref of asBreakdownList(breakdowns[rowKey(g,'available')])">
                    <span>{{ blLabelKey(ref.blLocal) | t }}: {{ ref.blNumber || '—' }}</span>
                    <span *ngIf="ref.invoiceAmount != null">{{ ref.invoiceAmount | number:'1.0-2' }} {{ ref.invoiceCurrency }}</span>
                    <a *ngIf="flags.showConsignmentLink" [routerLink]="['/consignments/consignment-view', ref.consignmentEncodedId]">
                      <i class="pi pi-external-link"></i>
                    </a>
                  </div>
                </ng-container>

                <div class="qs-expand-empty"
                     *ngIf="!(flags.showPriceInvoice && g.invoiceAmount != null) && !(flags.showBlNumber && g.blNumber) && !(flags.showMixedBreakdown && g.mixedConsignments)">
                  {{ 'quickSearch.noPurchasingInfo' | t }}
                </div>
              </div>

              <div class="qs-calc-toggle-row">
                <button type="button" class="qs-calc-toggle" (click)="toggleQuickPrice(rowKey(g,'available'), g.salePricePerCbm ?? null)">
                  <i class="pi pi-percentage"></i> {{ 'quickSearch.quickPrice' | t }}
                  <i class="pi" [class.pi-chevron-down]="!isQuickPriceOpen(rowKey(g,'available'))" [class.pi-chevron-up]="isQuickPriceOpen(rowKey(g,'available'))"></i>
                </button>
                <button type="button" class="qs-calculator-btn" [pTooltip]="'quickSearch.calculator' | t" tooltipPosition="top"
                        (click)="openCalculatorDialog(g.salePricePerCbm ?? null, g.salePricePerCbm != null ? 'quickSearch.pricePerCbm' : null, null)">
                  <i class="pi pi-calculator"></i>
                </button>
              </div>
              <div class="qs-calc" *ngIf="isQuickPriceOpen(rowKey(g,'available'))">
                <div class="qs-calc-row">
                  <label>{{ 'quickSearch.pricePerCbm' | t }}</label>
                  <input type="number" inputmode="decimal" class="qs-calc-input"
                         [ngModel]="calcPricePerCbm[rowKey(g,'available')]"
                         (ngModelChange)="onPricePerCbmInput(rowKey(g,'available'), $event)" />
                </div>
                <div class="qs-calc-row">
                  <label>{{ 'quickSearch.pricePerCft' | t }}</label>
                  <input type="number" inputmode="decimal" class="qs-calc-input"
                         [ngModel]="pricePerCft(rowKey(g,'available'))"
                         (ngModelChange)="onPricePerCftInput(rowKey(g,'available'), $event)" />
                </div>
                <div class="qs-calc-total">
                  <span>{{ g.availableCbm | number:'1.1-2' }} CBM × {{ 'quickSearch.pricePerCbm' | t }}</span>
                  <b>{{ calcTotal(rowKey(g,'available'), g.availableCbm) | number:'1.0-2' }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pending stock-in — tallied but never received into a real InventoryLot. Grouped the
             same way Available Now is (product+site+origin+quality+dimension); a group with more
             than one unit shows a count badge and expands into its individual units instead of
             navigating straight through — see openPendingGroup()/pendingGroupDims(). -->
        <div class="qs-bucket" *ngIf="result?.pendingStockIn?.length">
          <div class="qs-bucket-label qs-pending">
            <span class="qs-dot"></span>{{ 'quickSearch.pendingStockIn' | t }} — {{ pendingTotalUnits }}
            <span *ngIf="pendingTotalUnits !== result?.pendingStockIn?.length"> · {{ result?.pendingStockIn?.length }} {{ 'quickSearch.groups' | t }}</span>
          </div>
          <div class="qs-row-wrap" *ngFor="let g of result?.pendingStockIn; let i = index">
            <div class="qs-row qs-row--clickable" [class.qs-row--active]="isRowHighlighted(pendingBaseIndex + i)" (click)="openPendingGroup(g)">
              <div class="qs-pending-badge-disc">
                <i class="pi pi-clock"></i>
                <span class="qs-pending-badge-count" *ngIf="g.unitCount > 1">{{ g.unitCount }}</span>
              </div>
              <div class="qs-row-main">
                <span class="qs-row-title">{{ g.productName }}<span> · {{ pendingGroupDims(g) }}</span></span>
                <span class="qs-row-meta">
                  <ng-container *ngIf="g.unitCount === 1 && g.units[0] as soleUnit">
                    <span class="qs-meta-pill qs-meta-pill--id">{{ soleUnit.stockUnitId || soleUnit.transportId }}</span>
                    <span class="qs-meta-pill qs-meta-pill--unit" *ngIf="soleUnit.containerOrVehicleNumber"><i class="pi pi-truck"></i>{{ soleUnit.containerOrVehicleNumber }}</span>
                    <span class="qs-meta-pill qs-meta-pill--eta" *ngIf="soleUnit.expectedDelivery"><i class="pi pi-calendar"></i>{{ 'quickSearch.eta' | t }}: {{ soleUnit.expectedDelivery }}</span>
                  </ng-container>
                  <span class="qs-meta-pill qs-meta-pill--site" *ngIf="g.siteName"><i class="pi pi-map-marker"></i>{{ g.siteName }}</span>
                  <span class="qs-meta-pill qs-meta-pill--origin" *ngIf="g.originName"><i class="pi pi-globe"></i>{{ g.originName }}</span>
                  <span class="qs-meta-pill qs-meta-pill--quality" *ngIf="g.qualityLabel">{{ g.qualityLabel }}</span>
                </span>
                <div class="qs-row-stats">
                  <span class="qs-stat" *ngIf="g.totalPieces != null"><i class="pi pi-copy"></i>{{ g.totalPieces }} {{ 'quickSearch.pcs' | t }}</span>
                </div>
              </div>
              <div class="qs-row-fig">
                <span *ngIf="g.totalCbm != null">{{ g.totalCbm | number:'1.1-2' }} CBM</span>
                <button type="button" class="qs-expand-toggle" [pTooltip]="'quickSearch.details' | t" tooltipPosition="top"
                        (click)="$event.stopPropagation(); toggleExpand(rowKey(g,'pending-group'))">
                  <i class="pi" [class.pi-chevron-down]="!isExpanded(rowKey(g,'pending-group'))" [class.pi-chevron-up]="isExpanded(rowKey(g,'pending-group'))"></i>
                </button>
                <i class="pi pi-chevron-right qs-row-arrow" *ngIf="g.unitCount === 1"></i>
              </div>
            </div>

            <div class="qs-expand" *ngIf="isExpanded(rowKey(g,'pending-group'))" (click)="$event.stopPropagation()">
              <!-- Single-unit group: identical purchasing-details/quick-price content this row
                   always had, byte-for-byte, just reading from the group's one unit. -->
              <ng-container *ngIf="g.unitCount === 1 && g.units[0] as unit">
                <div class="qs-expand-grid">
                  <div class="qs-expand-block" *ngIf="flags.showPriceInvoice && unit.invoiceAmount != null">
                    <span class="qs-expand-label">{{ 'quickSearch.invoiceAmount' | t }}</span>
                    <span class="qs-expand-value">{{ unit.invoiceAmount | number:'1.0-2' }} {{ unit.invoiceCurrency }}</span>
                  </div>
                  <div class="qs-expand-block" *ngIf="flags.showBlNumber && unit.blNumber">
                    <span class="qs-expand-label">{{ blLabelKey(unit.blLocal) | t }}</span>
                    <span class="qs-expand-value">{{ unit.blNumber }}</span>
                  </div>
                  <a class="qs-expand-link" *ngIf="flags.showConsignmentLink && unit.consignmentEncodedId"
                     [routerLink]="['/consignments/consignment-view', unit.consignmentEncodedId]">
                    {{ 'quickSearch.viewConsignment' | t }} <i class="pi pi-external-link"></i>
                  </a>
                  <div class="qs-expand-empty" *ngIf="!(flags.showPriceInvoice && unit.invoiceAmount != null) && !(flags.showBlNumber && unit.blNumber)">
                    {{ 'quickSearch.noPurchasingInfo' | t }}
                  </div>
                </div>

                <div class="qs-calc-toggle-row">
                  <button type="button" class="qs-calc-toggle" (click)="toggleQuickPrice(rowKey(g,'pending-group'), null)">
                    <i class="pi pi-percentage"></i> {{ 'quickSearch.quickPrice' | t }}
                    <i class="pi" [class.pi-chevron-down]="!isQuickPriceOpen(rowKey(g,'pending-group'))" [class.pi-chevron-up]="isQuickPriceOpen(rowKey(g,'pending-group'))"></i>
                  </button>
                  <button type="button" class="qs-calculator-btn" [pTooltip]="'quickSearch.calculator' | t" tooltipPosition="top"
                          (click)="openCalculatorDialog(null, null, null)">
                    <i class="pi pi-calculator"></i>
                  </button>
                </div>
                <div class="qs-calc" *ngIf="isQuickPriceOpen(rowKey(g,'pending-group'))">
                  <div class="qs-calc-row">
                    <label>{{ 'quickSearch.pricePerCbm' | t }}</label>
                    <input type="number" inputmode="decimal" class="qs-calc-input"
                           [ngModel]="calcPricePerCbm[rowKey(g,'pending-group')]"
                           (ngModelChange)="onPricePerCbmInput(rowKey(g,'pending-group'), $event)" />
                  </div>
                  <div class="qs-calc-row">
                    <label>{{ 'quickSearch.pricePerCft' | t }}</label>
                    <input type="number" inputmode="decimal" class="qs-calc-input"
                           [ngModel]="pricePerCft(rowKey(g,'pending-group'))"
                           (ngModelChange)="onPricePerCftInput(rowKey(g,'pending-group'), $event)" />
                  </div>
                  <div class="qs-calc-total" *ngIf="unit.netCbm != null">
                    <span>{{ unit.netCbm | number:'1.1-2' }} CBM × {{ 'quickSearch.pricePerCbm' | t }}</span>
                    <b>{{ calcTotal(rowKey(g,'pending-group'), unit.netCbm) | number:'1.0-2' }}</b>
                  </div>
                </div>
              </ng-container>

              <!-- Multi-unit group: each individual pending unit, still directly clickable
                   through to Receive it — exactly what a plain row's click always did. -->
              <ng-container *ngIf="g.unitCount > 1">
                <div class="qs-pending-unit-row" *ngFor="let unit of g.units" (click)="openPendingStockIn(unit)">
                  <span class="qs-meta-pill qs-meta-pill--id">{{ unit.stockUnitId || unit.transportId }}</span>
                  <span class="qs-meta-pill qs-meta-pill--unit" *ngIf="unit.containerOrVehicleNumber"><i class="pi pi-truck"></i>{{ unit.containerOrVehicleNumber }}</span>
                  <span class="qs-meta-pill qs-meta-pill--eta" *ngIf="unit.expectedDelivery"><i class="pi pi-calendar"></i>{{ 'quickSearch.eta' | t }}: {{ unit.expectedDelivery }}</span>
                  <span class="qs-pending-unit-fig">
                    <span *ngIf="unit.pieces != null">{{ unit.pieces }} {{ 'quickSearch.pcs' | t }}</span>
                    <span *ngIf="unit.netCbm != null">· {{ unit.netCbm | number:'1.1-2' }} CBM</span>
                  </span>
                  <i class="pi pi-chevron-right"></i>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- In process -->
        <div class="qs-bucket" *ngIf="result?.inProcess?.length">
          <div class="qs-bucket-label qs-process"><span class="qs-dot"></span>{{ 'quickSearch.inProcess' | t }} — {{ result?.inProcess?.length }}</div>
          <div class="qs-row" [class.qs-row--clickable]="pageAccess.canOpen('processing')" *ngFor="let r of result?.inProcess; let i = index"
               [class.qs-row--active]="isRowHighlighted(processBaseIndex + i)" (click)="openInProcess(r)">
            <div class="qs-row-main">
              <span class="qs-row-title">{{ r.productName || r.runCode }}</span>
              <span class="qs-row-sub">{{ r.operatorName || '—' }}<span *ngIf="r.machineName"> · {{ r.machineName }}</span><span *ngIf="r.millSiteName"> · {{ r.millSiteName }}</span></span>
            </div>
            <div class="qs-row-fig qs-status">
              {{ r.status }}
              <i class="pi pi-chevron-right qs-row-arrow"></i>
            </div>
          </div>
        </div>

        <!-- Arriving / departing / preparing -->
        <ng-container *ngIf="result?.arriving as radar">
          <div class="qs-bucket" *ngIf="radar.arriving?.length">
            <div class="qs-bucket-label qs-arriving"><span class="qs-dot"></span>{{ 'quickSearch.arrivingSoon' | t }} — {{ radar.arriving.length }}</div>
            <div class="qs-row qs-row--clickable" *ngFor="let c of radar.arriving; let i = index"
                 [class.qs-row--active]="isRowHighlighted(arrivingBaseIndex + i)" (click)="openConsignment(c)">
              <div class="qs-row-main">
                <span class="qs-row-title">{{ c.consignee || c.shipper || c.blNumber }}</span>
                <span class="qs-row-sub">{{ c.blNumber || '—' }}</span>
              </div>
              <div class="qs-row-fig">
                {{ c.date }}
                <i class="pi pi-chevron-right qs-row-arrow"></i>
              </div>
            </div>
          </div>
          <div class="qs-bucket" *ngIf="radar.departing?.length">
            <div class="qs-bucket-label qs-arriving"><span class="qs-dot"></span>{{ 'quickSearch.departingSoon' | t }} — {{ radar.departing.length }}</div>
            <div class="qs-row qs-row--clickable" *ngFor="let c of radar.departing; let i = index"
                 [class.qs-row--active]="isRowHighlighted(departingBaseIndex + i)" (click)="openConsignment(c)">
              <div class="qs-row-main">
                <span class="qs-row-title">{{ c.consignee || c.shipper || c.blNumber }}</span>
                <span class="qs-row-sub">{{ c.blNumber || '—' }}</span>
              </div>
              <div class="qs-row-fig">
                {{ c.date }}
                <i class="pi pi-chevron-right qs-row-arrow"></i>
              </div>
            </div>
          </div>
          <div class="qs-bucket" *ngIf="radar.preparing?.length">
            <div class="qs-bucket-label qs-preparing"><span class="qs-dot"></span>{{ 'quickSearch.preparing' | t }} — {{ radar.preparing.length }}</div>
            <div class="qs-row qs-row--clickable" *ngFor="let c of radar.preparing; let i = index"
                 [class.qs-row--active]="isRowHighlighted(preparingBaseIndex + i)" (click)="openConsignment(c)">
              <div class="qs-row-main">
                <span class="qs-row-title">{{ c.consignee || c.shipper || c.blNumber }}</span>
                <span class="qs-row-sub">{{ c.blNumber || '—' }}</span>
              </div>
              <div class="qs-row-fig qs-status">
                {{ c.status }}
                <i class="pi pi-chevron-right qs-row-arrow"></i>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <div class="qs-recent" *ngIf="!searched && !searching && !queryText.trim() && recentSearches.length">
      <div class="qs-recent-label">{{ 'quickSearch.recent' | t }}</div>
      <div class="qs-recent-pills">
        <button type="button" class="qs-recent-pill" *ngFor="let r of recentSearches" (click)="useRecentSearch(r)">
          <i class="pi pi-history"></i>
          <span>{{ r }}</span>
          <i class="pi pi-times qs-recent-remove" (click)="removeRecentSearch(r, $event)"></i>
        </button>
      </div>
    </div>

    <div class="qs-hint" *ngIf="!searched && !searching && (queryText.trim() || !recentSearches.length)">
      {{ 'quickSearch.hint' | t }}
    </div>
  </div>
  </ng-container>
</ng-template>

<p-dialog *ngIf="canUse && !embedded" [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="close()"
  [style]="{width:'620px'}" [breakpoints]="{'660px':'95vw'}" styleClass="qs-dialog" [showHeader]="false"
  appendTo="body">

  <div class="qs-input-row">
    <span class="qs-input-icon-badge"><i class="pi pi-search"></i></span>
    <input pInputText autofocus class="qs-input" [(ngModel)]="queryText" (ngModelChange)="onTextChange()"
      (keydown)="onInputKeydown($event)" [placeholder]="'quickSearch.placeholder' | t" />
    <button type="button" class="qs-ai-toggle" [class.qs-ai-toggle--on]="aiMode" (click)="toggleAiMode()"
      [pTooltip]="'quickSearch.ai.toggleTooltip' | t" tooltipPosition="bottom">
      <i class="pi pi-sparkles"></i> {{ 'quickSearch.ai.toggle' | t }}
    </button>
    <button type="button" class="qs-help-toggle" [class.qs-help-toggle--on]="showHelp" (click)="toggleHelp()"
      [pTooltip]="'quickSearch.help.toggleTooltip' | t" tooltipPosition="bottom">
      <i class="pi pi-question-circle"></i>
    </button>
    <span class="qs-close" (click)="close()">ESC</span>
  </div>

  <ng-container *ngTemplateOutlet="content"></ng-container>
</p-dialog>

<div *ngIf="embedded" class="qs-embedded">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<!-- Real calculator — standalone-only; embedded mode has its own Calculator mode at the shell
     level instead. Its own dialog, centered on the viewport, never anchored to a trigger button.
     A blank tool: startValue only ever prefills a convenience starting number, never restricts
     what the user types next. -->
<p-dialog *ngIf="canUse && !embedded" [(visible)]="calculatorDialogVisible" [modal]="true" [closable]="true"
  (onHide)="closeCalculatorDialog()" [style]="{width:'314px'}" [breakpoints]="{'380px':'92vw'}"
  styleClass="qs-calc-dialog" [showHeader]="false" appendTo="body">
  <app-simple-calculator
    [startValue]="calculatorStartValue"
    [startLabel]="calculatorStartLabel ? (calculatorStartLabel | t) : null"
    [currencyCode]="calculatorCurrency"
    [active]="calculatorDialogVisible"
    (closeRequested)="closeCalculatorDialog()">
  </app-simple-calculator>
</p-dialog>
